export const getFirstInSiteType = (items: any, item: any) => {
  const itemIndex = items.findIndex((i: any) => i.id === item.id);

  return (
    itemIndex === 0 ||
    items[itemIndex]?.siteType?.id !== items[itemIndex - 1]?.siteType?.id
  );
};
